import {
    cilAccountLogout,
    cilArrowBottom,
    cilArrowTop,
    cilBan,
    cilBell,
    cilCamera,
    cilCart,
    cilCheck,
    cilCheckCircle,
    cilChevronCircleUpAlt,
    cilChevronLeft,
    cilCloudUpload,
    cilDescription,
    cilEnvelopeClosed,
    cilFindInPage,
    cilFolder,
    cilFolderOpen,
    cilHamburgerMenu,
    cilHistory,
    cilHttps,
    cilLink,
    cilList,
    cilListHighPriority,
    cilMinus,
    cilNotes,
    cilPencil,
    cilPlus,
    cilPrint,
    cilReload,
    cilSave,
    cilSearch,
    cilSend,
    cilSpeech,
    cilStar,
    cilSwapVertical,
    cilSync,
    cilTag,
    cilTask,
    cilTrash,
    cilTransfer, 
    cilTruck,
    cilUser,
    cilVerticalAlignBottom,
    cilVerticalAlignCenter,
    cilWarning,
    cilX,
    cilXCircle,
    cilZoomIn,
    cilZoomOut,
} from '@coreui/icons';

export const iconsSet = Object.assign(
    {
        cilAccountLogout,
        cilArrowBottom,
        cilArrowTop,
        cilBan,
        cilBell,
        cilCamera,
        cilCart,
        cilCheck,
        cilCheckCircle,
        cilChevronCircleUpAlt,
        cilChevronLeft,
        cilCloudUpload,
        cilDescription,
        cilEnvelopeClosed,
        cilFindInPage,
        cilFolder,
        cilFolderOpen,
        cilHamburgerMenu,
        cilHistory,
        cilHttps,
        cilLink,
        cilList,
        cilListHighPriority,
        cilMinus,
        cilNotes,
        cilPencil,
        cilPlus,
        cilPrint,
        cilReload,
        cilSave,
        cilSearch,
        cilSend,
        cilSpeech,
        cilStar,
        cilSwapVertical,
        cilSync,
        cilTag,
        cilTask,
        cilTrash,
        cilTransfer, 
        cilTruck,
        cilUser,
        cilVerticalAlignBottom,
        cilVerticalAlignCenter,
        cilWarning,
        cilX,
        cilXCircle,
        cilZoomIn,
        cilZoomOut,
    },
);
